import React from 'react';
import './DownloadApp.css';

import { Heading } from '../../../components';
import { downloadApp } from '../../../constants';



const DownloadApp = () => {
  return (
    <section className="download-app">
      <div className="content">

        {/* Heading Section */}
        <Heading title={downloadApp.heading} subTitle={downloadApp.sub} linear sideHeading />

        {/* Description */}
        <p>{downloadApp.content}</p>

        {/* Download buttons */}
        <div className="btn-container">
          {downloadApp.buttons.map((button) => (
            <a key={button.id} href={button.link}>
              <img src={button.image} alt={button.alt} />
            </a>
          ))}
        </div>
      </div>

      {/* App preview image */}
      <div className="image">
        <img src={downloadApp.image} alt="SwiftRide Mobile App" />
      </div>

    </section>
  );
};

export default DownloadApp;